<template>
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="
                M16.0703 5.54492C16.1589 5.85482 16.0924 6.12044 15.8711 6.3418L14.4102
                7.66992C14.4544 7.93555 14.4766 8.21224 14.4766 8.5C14.4766 8.78776
                14.4544 9.06445 14.4102 9.33008L15.8711 10.6582C16.0924 10.8796 16.1589
                11.1452 16.0703 11.4551C15.9154 11.8535 15.7383 12.2409 15.5391
                12.6172L15.373 12.8828C15.1517 13.237 14.9082 13.5801 14.6426
                13.9121C14.4212 14.1556 14.1556 14.2331 13.8457 14.1445L11.9863
                13.5469C11.5436 13.901 11.0566 14.1777 10.5254 14.377L10.127 16.3027C10.0384
                16.6126 9.82812 16.8008 9.49609 16.8672C9.05339 16.9557 8.58854 17 8.10156
                17C7.61458 17 7.13867 16.9557 6.67383 16.8672C6.36393 16.8008 6.16471
                16.6126 6.07617 16.3027L5.67773 14.377C5.14648 14.1777 4.65951 13.901
                4.2168 13.5469L2.35742 14.1445C2.04753 14.2331 1.7819 14.1556 1.56055
                13.9121C1.27279 13.5801 1.0293 13.237 0.830078 12.8828L0.664062
                12.6172C0.464844 12.2409 0.28776 11.8646 0.132812 11.4883C0.0442708
                11.1562 0.110677 10.8796 0.332031 10.6582L1.79297 9.36328C1.7487 9.07552
                1.72656 8.78776 1.72656 8.5C1.72656 8.21224 1.7487 7.93555 1.79297
                7.66992L0.332031 6.3418C0.110677 6.12044 0.0442708 5.85482 0.132812
                5.54492C0.28776 5.14648 0.464844 4.75911 0.664062 4.38281L0.830078
                4.11719C1.0293 3.76302 1.27279 3.41992 1.56055 3.08789C1.7819 2.8444
                2.04753 2.76693 2.35742 2.85547L4.2168 3.45312C4.65951 3.09896 5.14648
                2.8112 5.67773 2.58984L6.07617 0.697266C6.16471 0.38737 6.375 0.199219
                6.70703 0.132812C7.14974 0.0442708 7.61458 0 8.10156 0C8.58854 0 9.06445
                0.0442708 9.5293 0.132812C9.83919 0.199219 10.0384 0.38737 10.127
                0.697266L10.5254 2.58984C11.0566 2.8112 11.5436 3.09896 11.9863
                3.45312L13.8457 2.85547C14.1556 2.76693 14.4212 2.8444 14.6426
                3.08789C14.9303 3.41992 15.1849 3.76302 15.4062 4.11719L15.5391
                4.38281C15.7383 4.75911 15.9154 5.14648 16.0703 5.54492ZM8.10156
                11.1562C9.09766 11.1341 9.86133 10.6914 10.3926 9.82812C10.8796 8.94271
                10.8796 8.05729 10.3926 7.17188C9.86133 6.30859 9.09766 5.86589 8.10156
                5.84375C7.10547 5.86589 6.3418 6.30859 5.81055 7.17188C5.32357 8.05729
                5.32357 8.94271 5.81055 9.82812C6.3418 10.6914 7.10547 11.1341 8.10156
                11.1562Z
            "
            fill="currentColor"
        />
    </svg>
</template>